import React, { useState, useEffect } from 'react'

import SingleRow from './SingleRow.js'
import SearchData from './SearchData.js'

const DataRows = ({ dataArray }) => { //dataArray passed in from the App.js

  const headerBoxes = document.getElementsByClassName('headerBox')
  const pathwayTag = document.getElementById('pathway')

  // SORTING CODE AND STATE

  const [ sortBy, setSortBy ] = useState('pathway')
  const [ sortedArray, setSortedArray ] = useState([])


  //need to add filters for animal and other stuff to weed out not available and sort the high/good/ok/low one uniquely
  const whichSort = (array, sortBy) => {
    if (sortBy === 'pathway' || sortBy === 'pathwayScore'){
      return array.sort((a,b)=> (a[sortBy] > b[sortBy] ? 1 : -1))
    } else if (sortBy === 'prcPapersAd' ){
      return array.sort((a,b)=> (Number(a[sortBy].slice(0, -1)) < Number(b[sortBy].slice(0, -1)) ? 1 : -1))
    } else if (sortBy === 'perAnimal' || sortBy === 'perGenetic' || sortBy === 'perHuman' || sortBy === 'perModel'){
      // const array2 = array.filter(obj => obj[sortBy] !== 'N/A')
      array.sort((a,b)=> (Number(a[sortBy].slice(0, -1)) < Number(b[sortBy].slice(0, -1)) ? 1 : -1))
      // console.log(array2.length, 'length array', array2.slice(0,4))
      return array
    } else if (sortBy === 'literatureRank' || sortBy === 'adSpecificPaperRank'){
      return array.sort((a,b)=> (Number(a[sortBy]) > Number(b[sortBy]) ? 1 : -1))
    } else {
      return array.sort((a,b)=> (Number(a[sortBy]) < Number(b[sortBy]) ? 1 : -1))
    }
  }

  useEffect(() => {
    setSortedArray(whichSort(dataArray, sortBy))
    console.log(sortedArray.slice(0,4), 'sorted array')
  }, [sortBy, dataArray])


  // INITIALIZE HEADERS AND HANDLE CLICKING ON HEADERS

  const handleClick = (event) => {
    if (event.target.style.color !== 'blue'){
      for (let i = 0; i < headerBoxes.length; i++) {
        headerBoxes[i].style.color = 'black'
      }
      pathwayTag.style.color = 'black'
      setSortBy(event.target.id)
      event.target.style.color = 'blue'

    } else {
      event.target.style.color = 'black'
      setSortBy('pathway')
      pathwayTag.style.color = 'blue'
    }  
  }

  // SEARCH FILTER CODE

  const [ filteredData, setFilteredData ] = useState([])
  const [ filters, setFilters ] = useState({ searchTerm: '' })

  const handleFilterChange = () => {
    const newObj = { ...filters, [event.target.name]: event.target.value }
    setFilters(newObj)
  }

  useEffect(() => {
    const regexSearch = new RegExp(filters.searchTerm, 'i')
    setFilteredData((sortedArray ? sortedArray : dataArray).filter(row => {
      return regexSearch.test(row.pathway)
    }))
  }, [filters, sortBy, sortedArray, dataArray])

  // INFO TOGGLE BUTTON

  const infoBox = document.getElementById('infoBox')
  const toggleInfo = document.getElementById('toggleInfo')

  const handleShow = () => {
    if (infoBox.style.display === 'flex') {
      infoBox.style.display = 'none'
      toggleInfo.style.color = 'black'
    } else {
      infoBox.style.display = 'flex'
      toggleInfo.style.color = 'blue'
    }
  }

  return (<>       
    <div className="container">
      <div className="searchPage" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <h1 style={{ marginBottom: '10px', marginTop: '10px' }}>Pathway Search</h1>
        <h2 style={{ marginBottom: '0px', marginTop: '0px' }}>Enter a KEGG pathway to check its association to Alzheimer&apos;s disease via the literature.</h2>
        <h2 style={{ marginTop: '0px', marginBottom: '0px' }}>Click extra info for header descriptions.</h2>
        <h2 style={{ marginTop: '0px', marginBottom: '10px' }}>To sort by a column, click on that columns&apos; header.</h2>
        <button id="toggleInfo" onClick={ handleShow } style={{ marginTop: '0px', marginBottom: '10px', width: '80px', padding: '5px' }}>Extra Info</button>
        <div id="infoBox" >
          <p className="infoDiv" >Papers: the total number of abstracts associating a pathway with dementia </p>
          <p className="infoDiv" >AD Papers: the total number of abstracts associating a pathway with Alzheimer&apos;s disease</p>
          <p className="infoDiv" >Pathway Score: how well the dictionary captures relevant papers to that pathway</p>
          <p className="infoDiv" >AD Word Score: based on all abstracts associated with that pathway, how often are AD-specific words found</p>
          <p className="infoDiv" >Lit Rank: overall rank of pathways associated with dementia</p>
          <p className="infoDiv" >AD Paper Rank: rank of pathways associated with Alzheimer&apos;s disease</p>
          <p className="infoDiv" >% AD: the percentage of papers that are specific to Alzheimer&apos;s disease</p>
          <p className="infoDiv" >% Animal: the percentage of papers that come from animal studies</p>
          <p className="infoDiv" >% Human: the percentage of papers that come from human studies</p>
          <p className="infoDiv" >% Genetic: the percentage of papers that come from genetic studies</p>
          <p className="infoDiv" >% Model: the percentage of papers that come from studies using models</p>
        </div>
        <SearchData handleFilterChange={handleFilterChange} {...filters}/>
        <div className="excelRow" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p className="rowBox pathwayBox headerBox" id="pathway" onClick={handleClick} style={{ width: '390px' }}>Pathway</p>
          <div className="afterPathway" style={{ display: 'flex', width: '1210px' }}>
            <p className="rowBox headerBox" onClick={handleClick} id="totalNumberPapers" >Papers</p>
            <p className="rowBox headerBox" onClick={handleClick} id="adSpecificPaperCount" >AD Papers</p>
            <p className="rowBox headerBox" onClick={handleClick} id="pathwayScore" >Pathway Score</p>
            <p className="rowBox headerBox" onClick={handleClick} id="adWordScore" >AD Word Score</p>
            <p className="rowBox headerBox" onClick={handleClick} id="literatureRank" >Lit Rank</p>
            <p className="rowBox headerBox" onClick={handleClick} id="adSpecificPaperRank" >AD Paper Rank</p>
            <p className="rowBox headerBox" onClick={handleClick} id="prcPapersAd" >% AD</p>
            <p className="rowBox headerBox" onClick={handleClick} id="perAnimal" >% Animal</p>
            <p className="rowBox headerBox" onClick={handleClick} id="perHuman" >% Human</p>
            <p className="rowBox headerBox" onClick={handleClick} id="perGenetic" >% Genetic</p>
            <p className="rowBox headerBox" onClick={handleClick} id="perModel" >% Model</p>
          </div>
        </div>
        <div className="row">
          {( filters.searchTerm !== '' ? filteredData : dataArray ).map(row => { 
            return <SingleRow key={row.pathway} { ...row } />
          })}
        </div>
      </div>
    </div> 
  </>)
}

export default DataRows